// extracted by mini-css-extract-plugin
export var parcelRow = "_tl-0";